<template >
  <modal
    name="coursefiles"
    :classes="['app-slideover', ($theme.darkTheme ? 'bg-color-modal-dark' : 'bg-color-modal-light')]"
    height="100%"
    :width="calculatedWidth"
    :adaptive="true"
    :scrollable="true"
    :pivotX="0"
    :shiftX="0"
    transition="slide-right"
    overlayTransition
    @opened="load()"
    @before-close="hasActiveDownloads($event)"
    @closed="loading = true"

  >
    <HeaderPage pageName="Downloads" modalName="coursefiles" />
    <main
      v-if="loading"
      :class="($theme.darkTheme ? 'bg-color-modal-dark' : 'bg-color-modal-light')"
    >
      <content-placeholders>
        <content-placeholders-img :class="($theme.darkTheme ? 'loading-dark' : 'loading-light')" class="course-files-placeholder" />
      </content-placeholders>
    </main>
    <main v-else  :class="($theme.darkTheme ? 'bg-color-modal-dark' : 'bg-color-modal-light')">
      <div>
        <!-- A lista vive em componente próprio porque o app a renderiza também
             na aba "Materiais" do sheet de download. Este slideover continua
             sendo a superfície do desktop, sem mudança de comportamento. -->
        <CourseFilesList ref="filesList" @loading="loading = $event" />
      </div>
    </main>
  </modal>
</template>

<script>
import HeaderPage from "@/layout/HeaderPage";
import CourseFilesList from "@/components/CourseFilesList";
import { isMobile } from "mobile-device-detect";
import { mapState } from "vuex";

export default {
  name: "CourseFiles",
  props: ["layoutTheme"],
  components: {
    HeaderPage,
    CourseFilesList,
  },
  data() {
    return {
      loading: true,
    };
  },
  computed: {
    ...mapState({
      currentEnroll: (state) => state.enroll.current,
    }),
    calculatedWidth() {
      if (isMobile && (window.innerWidth < 600)) return "100%";
      else return "365px";
    },
  },
  methods: {
    // Guard de fechamento: com download em voo, fechar o slideover perderia o
    // arquivo no meio. A contagem agora mora na lista, então pergunta a ela.
    hasActiveDownloads(evt) {
      const list = this.$refs.filesList;
      if (list && list.hasActive()) {
        const payload = { message: "Aguarde os downloads", duration: 1000 };
        this.$store.commit("toast/NEW", payload);
        evt.cancel();
      }
    },
    async load() {
      await this.$store.dispatch("learningObject/getDRM", this.currentEnroll.courseId);

      this.loading = false;
    },
  },
};
</script>
<style scoped>
.course-files-placeholder {
  width: 100vw;
  height: 100vh;
}
</style>
